import { Button, ButtonBase, CardMedia, useTheme } from "@mui/material";
import { Schedule } from "@/types/branch";
import ScheduleAvailability from "@/components/ScheduleAvailability";
import "./DefaultFilled.scss";

interface DefaultFilledProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  image?: string;
  isDisabled?: boolean;
  onClick?: () => void;
  schedule?: Schedule;
}

const DefaultFilled = ({ title, description, price, image, isDisabled, onClick, schedule }: DefaultFilledProps) => {
  const theme = useTheme();
    
  return (
    <ButtonBase
      className="dish dish--default-filled"
      onClick={onClick}
      component="div"
      sx={{
        opacity: isDisabled ? 0.5 : 1,
        ["& .dish__title"]: {
          textDecoration: isDisabled ? "line-through" : "none",
        },
      }}
    >
      <CardMedia className="dish__image" component={"img"} title={title} image={image} />

      <div className="dish__body">
        <div className="dish__body-header">
          <h3 className="dish__title">{title}</h3>
          <p className="dish__price">{price}</p>
        </div>
        {schedule ? (
          <div className="dish__schedule">
            <ScheduleAvailability availability={schedule} />
          </div>
        ) : null}
        <p className="dish__description">{description}</p>

        <div className="dish__actions">
          <Button className="dish__btn-details" onClick={onClick} sx={{ backgroundColor: theme.palette.primary.main, color: "white" }}>
            Detalles
          </Button>
        </div>
      </div>
    </ButtonBase>
  );
};

export default DefaultFilled;
